var path = '/user/visionapi/no-active-plans.html';
var html = "<md-card-content layout-padding> <article class=plan-overview layout=column> <div layout=row> <h3> No active subscriptions.</h3> </div> <section flex layout=column> <div layout=row> <div>You can start by subscribing to </div> </div> <div layout=row> <ul> <li> <a href={{config.visionApiUrl}} target=_blank>Computer Vision API</a> </li> </ul> </div> </section> </article> </md-card-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./user/visionapi/no-active-plans.html
// module id = 294
// module chunks = 0